module.exports = __webpack_public_path__ + "static/media/oCurve-logo.ed7a1864.svg";